import { Action } from '@ngrx/store';

import { PublishActionStatus } from '®shared/reading-list/models';

import {
  ContainerEditActions,
  ContainerEditPayload,
} from './container-edit.actions';

export enum ContainerPersistEditActionTypes {
  PERSIST = '[Persist list edit] persist',
  PERSIST_SUCCESS = '[Persist list edit] persist success',
  PERSIST_ERROR = '[Persist list edit] persist error',

  PERSIST_PUBLISH_LIST = '[Persist list edit] Publish list',
  PERSIST_RESUME_PUBLISH_LIST = '[Persist list edit] Resume publish list',
  PERSIST_PUBLISH_LIST_CHECK = '[Persist list edit] (Re)check publishing of list',
}

export class PersistAction implements Action {
  readonly dateCreated: Date;
  readonly editAction: ContainerEditActions;
  type = ContainerPersistEditActionTypes.PERSIST;

  constructor(editAction: ContainerEditActions) {
    this.dateCreated = new Date();
    this.editAction = editAction;
  }
}

export interface PersistSuccess {
  etag: string;
}

export type PersistSuccessPayload = PersistSuccess & {
  persistAction: PersistAction;
};

export interface PersistError {
  error: any;
}

export class PersistSuccessAction implements Action {
  readonly type = ContainerPersistEditActionTypes.PERSIST_SUCCESS;

  constructor(public payload: PersistSuccessPayload) {}
}

export class PersistErrorAction implements Action {
  readonly type = ContainerPersistEditActionTypes.PERSIST_ERROR;

  constructor(public payload: PersistError) {}
}

export interface PublishListCheckPayload extends ContainerEditPayload {
  persistAction: PersistAction;
  id: string;
  listEtag: string;
  status: PublishActionStatus;
  retryCount: number;
  reviewUrl?: string;
}

export class PersistPublishListAction extends PersistAction {
  readonly type = ContainerPersistEditActionTypes.PERSIST_PUBLISH_LIST;
}

export class PersistResumePublishListAction extends PersistAction {
  readonly type = ContainerPersistEditActionTypes.PERSIST_RESUME_PUBLISH_LIST;
}

export class PersistPublishListCheckAction implements Action {
  readonly type = ContainerPersistEditActionTypes.PERSIST_PUBLISH_LIST_CHECK;

  constructor(public payload: PublishListCheckPayload) {}
}
